<template>
  <div class="container article">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>信息资讯</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">信息资讯</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleToCategory"
          >分类管理</el-button>
          <el-button
            class="button"
            type="primary"
            @click="handleArticelCreate"
          >发布文章</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="文章名称"
          prop="name"
        >
          <el-input
            v-model="query.keyword"
            placeholder="输入文章名称"
            @input="fetchArticleList(true)"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            class="datetime"
            v-model="createDatetime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="fetchArticleList(true)"
            :style="{'width':isfixed?'400px':'260px'}"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="院校"
          prop="college"
        >
          <el-select
            v-model="query.college_code"
            filterable
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              v-for="(item, index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分类"
          prop="category_id"
        >
          <el-select
            v-model="query.category_id"
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="学长搜索"
          prop="name"
        >
          <el-input
            v-model="query.author"
            placeholder="输入学长手机号，真实姓名"
            style="width:300px;"
            @input="fetchCourseList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <!--       <el-form-item label="钉钉推送状态">
          <el-select
            v-model="query.is_ding_push"
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              label="已推送"
              :value="1"
            >
            </el-option>
            <el-option
              label="未推送"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="数据是否完整">
          <el-select
            v-model="query.is_data_complete"
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              label="完整"
              :value="1"
            >
            </el-option>
            <el-option
              label="不完整"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序方式">
          <el-select
            v-model="query.sort_type"
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              label="发布时间倒序"
              :value="0"
            >
            </el-option>
            <el-option
              label="创建时间倒序"
              :value="1"
            >
            </el-option>
            <el-option
              label="更新时间倒序"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">文章列表</h3>
        <el-form
          :inline="true"
          label-width="70px"
          size="small"
        >
          <el-form-item>
            <el-radio-group
              v-model="query.status"
              @change="fetchArticleList(true)"
            >
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>

        </el-form>
      </div>
      <div class="tabs">
        <el-tabs
          v-model="tabName"
          @tab-click="handleTabChange"
        >
          <el-tab-pane
            label="全部商品"
            name="all"
          ></el-tab-pane>
          <el-tab-pane
            label="学长商品"
            name="senior"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="values">
        <el-table
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            width="80"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            width="400"
            label="标题"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="分类"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formateCategory_id(scope.row.category_id) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="tags_real"
            width="300"
            label="标签"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="tag-wrap"
                @click="changeTags_real(scope.row)"
              >
                <el-tag
                  v-for="(item,index) in scope.row.tags_real.length?scope.row.tags_real.split(','):[]"
                  :key="index"
                  type=""
                >
                  {{ item }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="tags"
            width="300"
            label="来源"
            align="center"
          >
          </el-table-column>
          <!--         <el-table-column
            width="100"
            label="钉钉推送状态"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.is_ding_push?'已推送':'未推送'}}
            </template>
          </el-table-column> -->

          <!--     <el-table-column
            prop="service"
            label="描述"
            width="300"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.description }}
              </div>      
            </template>
          </el-table-column> -->

          <el-table-column
            prop="pv"
            label="浏览量"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.pv - scope.row.virtual_pv }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="发布日期"
            align="center"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.publish_time?$moment(scope.row.publish_time).format("YYYY-MM-DD"):""}}
            </template>
          </el-table-column>
          <el-table-column
            label="更新日期"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学长"
            width="180"
            align="center"
            v-if="query.is_author==1"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{scope.row.author.mobile }}</span></template>
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="small"
                :type="scope.row.status == 1 ? 'success' : 'danger'"
              >{{ scope.row.status == 1 ? "上架" : "下架" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            label="文章是否完整"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.is_data_complete?'完整':'不完整'}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="230"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="goDetail(scope.row)"
              >编辑</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="handleToPreview(scope.row)"
              >浏览</el-link>
              <!--     <el-link
                type="primary"
                :underline="false"
                @click="handleToClone(scope.row.id)"
              >复制</el-link> -->
              <el-link
                type="primary"
                :underline="false"
                @click="handleToOrigin(scope.row)"
              >原文链接</el-link>
              <el-link
                type="danger
            "
                @click="handleArticleRemove(scope.row.id)"
                :underline="false"
              >删除</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="goDetail(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="b"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToPreview(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToClone(scope.row.id)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleArticleRemove(scope.row.id)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <ChangeTagsReal
      @close="editDialog = false"
      :visible="editDialog"
      @submit="fetchArticleList()"
      :content="editContent"
    />
  </div>
</template>

<script>
import ArticleCard from "@/components/card/Article";
import ChangeTagsReal from "@/components/dialog/article/ChangeTagsReal";
import {
  articleList,
  articleDestroy,
  articleCategoryList,
  articleClone,
} from "@/api/article";

export default {
  components: {
    ArticleCard,
    ChangeTagsReal
  },
  data() {
    return {
      createDialog: false,
      query: {
        name: "",
        author: "",
        startTime: "",
        endTime: "",
        subject: "",
        status: "",
        sort: "1",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        sort_type: 0,
      },
      createDatetime: "",
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "上架", value: "1" },
          { label: "下架", value: "0" },
        ],
        sorts: [
          { label: "最新", value: "1" },
          { label: "最热", value: "2" },
        ],
      },
      categorys: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: "",
      editContent: {},
      editDialog: false,
    };
  },
  created() {
    this.parseQuery();
    this.fetchCategoryList();
    this.fetchArticleList();
    this.$store.dispatch("getAllColleges");
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf();
        this.query.endTime = this.$moment(value[1]).valueOf();
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
    },
  },
  methods: {
    // 文章列表请求
    fetchArticleList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      articleList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分类列表请求
    fetchCategoryList() {
      articleCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list;
      });
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === "sort") {
        this.query.sort = value;
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchArticleList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchArticleList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchArticleList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      // 手动处理
      this.createDatetime = null;
      setTimeout(() => {
        this.fetchArticleList();
      }, 20);
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/article/category`);
    },
    // 文章创建
    handleArticelCreate() {
      this.$router.push(`/article/create`);
    },
    // 文章删除
    handleArticleRemove(materialId) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          articleDestroy({ id: materialId }).then((res) => {
            this.$message.success(`删除成功`);
            this.fetchArticleList();
          });
        })
        .catch(() => { });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ];
      }
      if (this.query.sort_type) {
        this.query.sort_type = Number(this.query.sort_type)
      }
      this.tabName = this.query.is_author == 1 ? "senior" : "all"
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    formateCategory_id(id) {
      if (this.categorys.length && id) {
        return this.categorys.find((v) => {
          return v.id == id;
        }).name;
      }

    },
    // 表格操作跳转页面
    goDetail(item) {
      this.$router.push(`/article/edit/${item.id}`);
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes("admin.kaoyanbox.com")) {
          window.open(`https://h5.kaoyanbox.com/article/detail/${item.id}`);
        } else {
          window.open(`http://h5.kaoyanbox.net/article/detail/${item.id}`);
        }
      }
    },
    handleToClone(id) {
      // 二次确认
      this.$confirm("确定要复制吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          articleClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`);
            this.fetchArticleList();
          });
        })
        .catch(() => { });
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchArticleList(true)
    },
    changeTags_real(row) {
      this.editContent = Object.assign({}, row)
      this.editDialog = true
    },
    handleToOrigin(row) {
      if (row.origin_url) {
        window.open(row.origin_url)
      } else {
        this.$message.error('暂无原文链接')
      }
    }
  },
};
</script>

<style scoped lang="less">
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
</style>
